import React from "react";
import c20Pro from "../assets/images/Landi C20 Pro Dual Premier.png";
import c20ProSE from "../assets/images/Landi C20 Pro SE Dual Premier.png";
import c20ProSESingle from "../assets/images/Landi C20 Pro SE Single.png";
import c20DS from "../assets/images/Landi C20 DS.png";
import m20SE from "../assets/images/Landi M20 SE.png";
import m20 from "../assets/images/Landi M20.png";
import wifiIcon from "../assets/svg/wifi.svg";
import chipIcon from "../assets/svg/chip.svg";
import screenIcon from "../assets/svg/screen.svg";
import android from "../assets/svg/android.svg";

function HardwareSolutions() {
  const hardwareModels = [
    {
      name: "Landi C20 Pro Dual Premier",
      specs: [
        { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi", subtitle: "Network Transmission" },
        { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "4GB + 64GB", subtitle: "Memory and Storage" },
        { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: '15.6" 1920 x 1080', subtitle: "Main Display" },
        { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 13", subtitle: "Operating System" },
      ],
      image: c20Pro,
      bgColor: "bg-gray-50",
    },
    {
      name: "Landi C20 Pro SE Dual Premier",
      specs: [
        { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi", subtitle: "Network Transmission" },
        { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "4GB + 64GB", subtitle: "Memory and Storage" },
        { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: '15.6" 1920 x 1080', subtitle: "Main Display" },
        { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 13", subtitle: "Operating System" },
      ],
      image: c20ProSE,
      bgColor: "bg-gray-50",
    },
    {
      name: "Landi C20 Pro SE Single",
      specs: [
        { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi", subtitle: "Network Transmission" },
        { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "4GB + 64GB", subtitle: "Memory and Storage" },
        { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: '15.6" 1920 x 1080', subtitle: "Main Display" },
        { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 13", subtitle: "Operating System" },
      ],
      image: c20ProSESingle,
      bgColor: "bg-gray-50",
    },
    {
      name: "Landi C20 DS",
      specs: [
        { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi", subtitle: "Network Transmission" },
        { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "4GB + 32GB", subtitle: "Memory and Storage" },
        { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: '15.6" 1920 x 1080', subtitle: "Main Display" },
        { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 13", subtitle: "Operating System" },
      ],
      image: c20DS,
      bgColor: "bg-gray-50",
    },
    {
      name: "Landi M20",
      specs: [
        { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi", subtitle: "Network Transmission" },
        { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "3GB + 32GB Flash", subtitle: "Memory and Storage" },
        { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: '5.5" 720 x 1280', subtitle: "Main Display" },
        { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 13", subtitle: "Operating System" },
      ],
      image: m20,
      bgColor: "bg-gray-50",
    },
    {
      name: "Landi M20 SE",
      specs: [
        { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi", subtitle: "Network Transmission" },
        { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "3GB + 32GB Flash", subtitle: "Memory and Storage" },
        { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: '5.5" 720 x 1280', subtitle: "Main Display" },
        { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 13", subtitle: "Operating System" },
      ],
      image: m20SE,
      bgColor: "bg-gray-50",
    } /*{
            name: "Landi C20 Pro",
            specs: [
                { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi + 4G (SIM)", subtitle: "Network Connection" },
                { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "8GB + 128GB", subtitle: "Memory and Storage" },
                { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: "15.6\" 1920 x 1080", subtitle: "Main Display" },
                { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 13", subtitle: "Operating System" }
            ],
            image: LandIMG,
            bgColor: "bg-gray-50"
        },
        {
            name: "iMin D4 Pro",
            specs: [
                { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi 6", subtitle: "Network Connection" },
                { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "4GB + 64GB", subtitle: "Memory and Storage" },
                { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: "15.6\" 1920 x 1080", subtitle: "Main Display" },
                { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 13", subtitle: "Operating System" }
            ],
            image: iMinIMG,
            bgColor: "bg-gray-50"
        },
        {
            name: "WizarPOS Q2",
            specs: [
                { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi + 4G (SIM)", subtitle: "Network Connection" },
                { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "2GB + 32GB", subtitle: "Memory and Storage" },
                { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: "5.5\" 720 x 1280", subtitle: "Main Display" },
                { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 14", subtitle: "Operating System" }
            ],
            image: wizarQ2IMG,
            bgColor: "bg-gray-50"
        },
        {
            name: "WizarPOS Q8",
            specs: [
                { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi + 4G (SIM)", subtitle: "Network Connection" },
                { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "2GB + 16GB", subtitle: "Memory and Storage" },
                { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: "8\" 800 x 1280", subtitle: "Main Display" },
                { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 10", subtitle: "Operating System" }
            ],
            image: wizarQ8IMG,
            bgColor: "bg-gray-50"
        }*/,
  ];

  return (
    <section className="py-16 px-4 bg-white">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-6xl font-bold text-black mb-4">Explore Our POS Hardware Solutions</h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Choose the right setup for your business. All models are fully compatible with our VernPOS system.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {hardwareModels.map((model, index) => (
            <div key={index} className={`bg-gray-100 border-gray border-2 rounded-3xl text-left p-8`}>
              <div className="flex flex-col lg:flex-row items-center gap-8">
                {/* Specifications */}
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-vern mb-6">{model.name}</h3>

                  <div className="space-y-4">
                    {model.specs.map((spec, specIndex) => (
                      <div key={specIndex} className="flex items-center gap-3">
                        <span className="text-2xl">{spec.icon}</span>
                        <div>
                          <div className="font-semibold text-gray-800">{spec.text}</div>
                          <div className="text-sm text-gray-600">{spec.subtitle}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Product Image */}
                <div className="flex-1 text-center">
                  <img src={model.image} alt={model.name} className="max-w-full h-auto max-h-80 object-contain mx-auto" />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">
            Need help choosing the right hardware for your business?
          </p>
          <button className="bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-8 rounded-full transition-colors duration-300 mr-4">
            Contact Our Experts
          </button>
          <button className="border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white font-semibold py-3 px-8 rounded-full transition-colors duration-300">
            Request Quote
          </button>
        </div> */}
      </div>
    </section>
  );
}

export default HardwareSolutions;
